module.exports = __webpack_public_path__ + "img/240.11df48ff.jpg";